import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
    maxWidth: '250px',
  },
  inputWrapper: {
    display: 'flex',
    columnGap: theme.spacing(2),
    alignItems: 'center'
  },
  inputContainer: {
    marginRight: theme.spacing(2),
    width: '100%'
  },
  select: {
    minWidth: 50,
    maxWidth: 300,
    width: '100%',
    textOverflow: 'ellipsis',
  },
}));

export default useStyles;
